module.exports = __webpack_public_path__ + "media/images/fullscreen/root_homes-bea5cd10ccac2fe976a03cd585bcb170.png";